import { numberOrZero } from "@/utils/utils";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import { CONTRACT_ROUTE_PATHS } from "../../../../../contract/paths";
import { percentageChange } from "../../../../utils";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatNumber } from "./common/StatNumber";
import { TrendIndicator } from "./common/TrendIndicator";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: { contractsCount: number; previousContractsCount?: number };
};

export const ContractsData = ({ data }: Props) => {
  const { t } = useTranslation();

  const statChange = percentageChange(data.contractsCount, numberOrZero(data.previousContractsCount));

  return (
    <div>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="geekblue" icon={<AntIcon type="audit" />} />

        <div>
          <span style={{ fontSize: 21, paddingLeft: 8, marginRight: 4 }}>
            {t("dashboard.statistics.contractsCount")}
          </span>

          <TrendIndicator value={statChange} />
        </div>
      </Flex>

      <Flex justify="center" className="margin-top-medium" style={{ height: STATS_HEIGHT }}>
        <Link className="no-link-color-hover" to={CONTRACT_ROUTE_PATHS.list.to}>
          <StatNumber value={data.contractsCount} />
        </Link>
      </Flex>
    </div>
  );
};
